/*
 * Perfect Optics – article content enhancer
 * Lets editors paste straight from Google Docs / Word into the Shopify editor.
 * Cleans pasted formatting and applies the blog styles automatically:
 *  - removes Google Docs inline styles (fonts, spacing, colours) but keeps bold/italic
 *  - removes empty paragraphs and a duplicated title
 *  - "Styling tip:", "Tip:", "Pro tip:", "Note:" paragraphs  -> highlighted tip box
 *  - "Frequently Asked Questions" / "FAQs" section          -> styled FAQ list
 *  - tables                                                  -> styled, scrollable on mobile
 *  - external links                                          -> open in a new tab
 */
(function () {
  function enhance(root) {
    if (root.dataset.poEnhanced) return;
    root.dataset.poEnhanced = '1';

    // 1. Unwrap Google Docs' outer <b id="docs-internal-guid-…"> wrapper
    root.querySelectorAll('b[id^="docs-internal-guid"]').forEach(function (b) {
      b.replaceWith.apply(b, Array.from(b.childNodes));
    });

    // 2. Styled spans -> <strong>/<em> (keep meaning), drop the rest of the styling
    root.querySelectorAll('span[style]').forEach(function (span) {
      var st = span.style;
      var weight = parseInt(st.fontWeight, 10);
      var bold = st.fontWeight === 'bold' || weight >= 600;
      var italic = st.fontStyle === 'italic';
      var node = document.createDocumentFragment();
      while (span.firstChild) node.appendChild(span.firstChild);
      if (italic) { var em = document.createElement('em'); em.appendChild(node); node = em; }
      if (bold) { var strong = document.createElement('strong'); strong.appendChild(node); node = strong; }
      span.replaceWith(node);
    });
    root.querySelectorAll('[style]').forEach(function (el) {
      if (!/^(IMG|IFRAME|VIDEO)$/.test(el.tagName)) el.removeAttribute('style');
    });
    root.querySelectorAll('[dir="ltr"]').forEach(function (el) { el.removeAttribute('dir'); });

    // 3. Remove empty paragraphs / line breaks Docs leaves behind
    root.querySelectorAll('p').forEach(function (p) {
      if (!p.textContent.trim() && !p.querySelector('img, iframe, video')) p.remove();
    });

    // 4. Headings: drop a duplicated article title, demote any other H1 to H2
    var title = (document.querySelector('h1') || {}).textContent;
    root.querySelectorAll('h1').forEach(function (h1, i) {
      if (i === 0 && title && h1.textContent.trim() === title.trim() && root.firstElementChild === h1) {
        h1.remove();
      } else {
        var h2 = document.createElement('h2');
        h2.innerHTML = h1.innerHTML;
        h1.replaceWith(h2);
      }
    });

    // 5. Tip boxes
    root.querySelectorAll('p').forEach(function (p) {
      if (/^(styling tip|pro tip|tip|note)\s*:/i.test(p.textContent.trim())) p.classList.add('po-tip');
    });

    // 6. Tables
    root.querySelectorAll('table').forEach(function (table) {
      table.classList.add('po-table');
      if (!table.parentElement.classList.contains('po-table-wrap')) {
        var wrap = document.createElement('div');
        wrap.className = 'po-table-wrap';
        table.before(wrap);
        wrap.appendChild(table);
      }
      // first row as header if the table has no <th>
      if (!table.querySelector('th')) {
        var first = table.querySelector('tr');
        if (first) first.querySelectorAll('td').forEach(function (td) {
          var th = document.createElement('th');
          th.innerHTML = td.innerHTML;
          td.replaceWith(th);
        });
      }
    });

    // 7a. FAQs managed in the FAQs metafield block -> drop any duplicate FAQ left in the article text
    if (document.querySelector('.po-article-faq')) {
      var dupHead = Array.from(root.querySelectorAll('h2, h3, h4, p')).find(function (el) {
        return /^(frequently asked questions|faqs?)\s*:?$/i.test(el.textContent.trim());
      });
      if (dupHead) {
        var cur = dupHead;
        while (cur) {
          var nxt = cur.nextElementSibling;
          if (cur !== dupHead && cur.tagName === 'H2') break;
          cur.remove();
          cur = nxt;
        }
      }
    }

    // 7b. FAQ section: everything after a "Frequently Asked Questions" / "FAQs" heading
    else if (!root.querySelector('.po-faq')) {
      var faqHead = Array.from(root.querySelectorAll('h2, h3, h4, p')).find(function (el) {
        return /^(frequently asked questions|faqs?)\s*:?$/i.test(el.textContent.trim());
      });
      if (faqHead) {
        if (faqHead.tagName !== 'H2') {
          var h = document.createElement('h2');
          h.textContent = faqHead.textContent.trim();
          faqHead.replaceWith(h);
          faqHead = h;
        }
        var box = document.createElement('div');
        box.className = 'po-faq';
        var el = faqHead.nextElementSibling;
        while (el && el.tagName !== 'H2') {
          var next = el.nextElementSibling;
          var text = el.textContent.trim();
          if (/^H[3-6]$/.test(el.tagName) || (el.tagName === 'P' && /\?$/.test(text))) {
            var q = document.createElement('h3');
            q.textContent = text;
            box.appendChild(q);
            el.remove();
          } else {
            box.appendChild(el);
          }
          el = next;
        }
        faqHead.after(box);
      }
    }

    // 8. External links open in a new tab
    root.querySelectorAll('a[href^="http"]').forEach(function (a) {
      if (a.hostname && a.hostname !== location.hostname && !/perfectoptics\.in$/.test(a.hostname)) {
        a.target = '_blank';
        a.rel = 'noopener';
      }
    });
  }

  function run() {
    document.querySelectorAll('.article-template__content').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
